module.exports = __webpack_public_path__ + "img/_russia.fad876cb.png";